import { render, staticRenderFns } from "./Product1.vue?vue&type=template&id=5f7afe96&scoped=true&"
import script from "./Product1.vue?vue&type=script&lang=js&"
export * from "./Product1.vue?vue&type=script&lang=js&"
import style0 from "./Product1.vue?vue&type=style&index=0&id=5f7afe96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7afe96",
  null
  
)

export default component.exports